import axios from '@/utils/api'
import modulo from '@/utils/modulo'

const actions = {

  async findMunicipiosByUf ({ commit }, codigoEstado) {
    const municipios = await axios({
      method: 'get',
      url: modulo.PUBLICO + '/findByCodigoEstado',
      params: {
        codigoEstado
      }
    })
    return municipios
  },

  async findMunicipiosByEstadoAtualPromise ({ commit }) {
    return axios({
      method: 'get',
      url: modulo.PUBLICO + '/findByCodigoEstado',
      params: {
        codigoEstado: (process.env.ESTADO).toUpperCase()
      }
    })
  },

  async findMunicipiosByEstadoAtual ({ commit }) {
    const municipios = await axios({
      method: 'get',
      url: modulo.PUBLICO + '/findByCodigoEstado',
      params: {
        codigoEstado: (process.env.ESTADO).toUpperCase()
      }
    })
    return municipios
  },

  async findMunicipioById ({ commit }, municipioId) {
    const municipio = await axios({
      method: 'get',
      url: modulo.PUBLICO + `/findMunicipio/${municipioId}`
    })
    return municipio
  },

  async findMunicipioByCadastros ({ commit }, municipioId) {
    const municipio = await axios({
      method: 'get',
      url: modulo.PUBLICO + `/findByCadastros`,
      loader: false
    })
    return municipio
  },

  async findMunicipiosBySetorLogado ({ commit }) {
    const municipios = await axios({
      method: 'get',
      url: 'municipio/findBySetorLogado'
    })
    return municipios
  }
}

export default {
  namespaced: true,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/portal/seguranca/municipios.js